import { render, staticRenderFns } from "./footmark.vue?vue&type=template&id=4891ce50&scoped=true"
import script from "./footmark.vue?vue&type=script&lang=js"
export * from "./footmark.vue?vue&type=script&lang=js"
import style0 from "./footmark.vue?vue&type=style&index=0&id=4891ce50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4891ce50",
  null
  
)

export default component.exports